import { Injectable } from '@angular/core';
import { News } from '../../model/communication/news.model';
import { Profile } from '../../model/profile.model';

@Injectable({providedIn: 'root'})
export class DataLayerService {
    private readonly dataLayer: Array<object>;

    highlightedNews(news: News): void {
        if (!this.dataLayer) {
            return;
        }

        this.resetLayer();
        this.dataLayer.push({
            event: 'highlightedNewsButton',
            data: {
                id: news.id,
                title: news.title,
                link: news.link,
            },
        });
    }

    login(profile: Profile): void {
        if (!this.dataLayer) {
            return;
        }

        this.resetLayer();
        this.dataLayer.push({
            event: 'login',
            method: 'username',
            user: {
                username: profile.username,
                establishment: profile.establishment,
                contactFunction: profile.contactFunction,
                category: profile.category,
                fullname: profile.fullname,
                sector: profile.sectorName,
                isPro: profile.isPro,
                establishmentType: profile.establishmentType,
                department: profile.department,
                firstContactDate: profile.firstContactDate,
                commercial: profile.commercialName,
                networkCommercial: profile.networkCommercialName,
            },
        });
    }

    private resetLayer(): void {
        if (!this.dataLayer) {
            return;
        }
        // Never reset `user` custom index
        this.dataLayer.push({
            method: null,
            data: null,
            ecommerce: null,
        });
    }

    constructor() {
        // window.dataLayer depends on fourth argument in analytics component when building GTM script tag
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.dataLayer = (window as any).dataLayer;
    }
}
